<y42-canvas-main-toolbar [dragBoundary]="cdkDragBoundary ?? ''">
  <y42-insert-shape-button
    (selectTool)="activateShapeInsertionTool($event.svg)"
    [isCanvasEditable]="state.isCanvasEditable"
  >
  </y42-insert-shape-button>
  <y42-insert-connection-line-button
    (selectTool)="activateConnectionLineTool()"
    [isCanvasEditable]="state.isCanvasEditable"
  ></y42-insert-connection-line-button>
  <y42-insert-textarea-button (selectTool)="activateTextInsertionTool()" [isCanvasEditable]="state.isCanvasEditable">
  </y42-insert-textarea-button>
  <y42-upload-image-button
    (selectTool)="activateImageInsertionTool($event)"
    [isCanvasEditable]="state.isCanvasEditable"
  >
  </y42-upload-image-button>
  <y42-create-drawing-button
    (selectTool)="activateDrawingTool($event)"
    [isCanvasEditable]="state.isCanvasEditable"
  ></y42-create-drawing-button>
  <y42-insert-sticky-note-button
    (selectTool)="activateStickyNoteInsertionTool($event)"
    [isCanvasEditable]="state.isCanvasEditable"
  ></y42-insert-sticky-note-button>
  <y42-group-nodes-button
    (selectTool)="activateGroupNodesTool()"
    [isCanvasEditable]="state.isCanvasEditable"
  ></y42-group-nodes-button>
  <y42-insert-attention-node-button
    (selectTool)="activateAttentionNodeInsertionTool()"
    [isCanvasEditable]="state.isCanvasEditable"
  ></y42-insert-attention-node-button>
  <y42-create-comment-button
    (selectTool)="activateCommentInsertionTool()"
    [isCanvasEditable]="state.isCanvasEditable"
  ></y42-create-comment-button>
  <y42-insert-emoji-button
    (selectTool)="activateEmojiInsertionTool($event)"
    [isCanvasEditable]="state.isCanvasEditable"
  ></y42-insert-emoji-button>
  <!-- TODO: Consider moving these items to the top toolbar instead -->
  <y42-show-more-menu-button>
    <y42-download-png-button (downloadPng)="onDownloadPngClick($event)"></y42-download-png-button>
    <y42-show-grid-button
      (toggleShowGrid)="onToggleShowGrid($event)"
      [showGrid]="state.showGrid"
    ></y42-show-grid-button>
  </y42-show-more-menu-button>
</y42-canvas-main-toolbar>

<y42-canvas-context-menu-toolbar *ngIf="selectedObject && menuVisible" [position]="menuPosition">
  <ng-container *ngFor="let menuOptionGroup of menuConfiguration; trackBy: trackByValue; let first = first">
    <div class="menu-group-separator" *ngIf="!first"></div>
    <ng-container *ngFor="let menuOption of menuOptionGroup; trackBy: trackByValue" [ngSwitch]="menuOption">
      <y42-context-menu-font-family
        *ngSwitchCase="'fontFamily'"
        class="menu-group"
        [fontFace]="selectedObject.fontFamily"
        (fontFaceChanged)="updateNodeProperty('fontFamily', $event, true)"
      ></y42-context-menu-font-family>
      <y42-context-menu-font-size
        *ngSwitchCase="'fontSize'"
        class="menu-group"
        [fontSize]="selectedObject.fontSize"
        (fontSizeChanged)="updateNodeProperty('fontSize', $event, true)"
      ></y42-context-menu-font-size>
      <y42-context-menu-alignment
        *ngSwitchCase="'textAlignment'"
        class="menu-group"
        [alignment]="selectedObject.textAlignment"
        (alignmentChanged)="updateNodeProperty('textAlignment', $event)"
      ></y42-context-menu-alignment>
      <y42-context-menu-font-weight
        *ngSwitchCase="'fontWeight'"
        class="menu-group"
        [fontWeight]="selectedObject.fontWeight"
        (fontWeightChanged)="updateNodeProperty('fontWeight', $event, true)"
      ></y42-context-menu-font-weight>
      <y42-context-menu-border-color
        *ngSwitchCase="'lineColor'"
        class="menu-group"
        label="Line color"
        [borderColor]="selectedObject.lineColor"
        (borderColorChanged)="updateNodeProperty('lineColor', $event, true)"
      ></y42-context-menu-border-color>
      <y42-context-menu-border-style
        *ngSwitchCase="'lineStyle'"
        class="menu-group"
        label="Line style"
        [borderStyle]="selectedObject.lineStyle"
        (borderStyleChanged)="updateNodeProperty('lineStyle', $event, true)"
      ></y42-context-menu-border-style>
      <y42-context-menu-shadow
        *ngSwitchCase="'shadow'"
        class="menu-group"
        [shadow]="selectedObject.shadow"
        (shadowChanged)="updateNodeProperty('shadow', $event, true)"
      ></y42-context-menu-shadow>
      <y42-context-menu-lock
        *ngSwitchCase="'lock'"
        class="menu-group"
        [locked]="selectedObject.lock"
        (lockedChanged)="updateNodeProperty('lock', $event)"
      ></y42-context-menu-lock>
      <y42-context-menu-bring-to
        *ngSwitchCase="'bringToFrontBack'"
        class="menu-group"
        (bringToFront)="onBringToFront()"
        (sendToBack)="onSendToBack()"
      ></y42-context-menu-bring-to>
      <y42-context-menu-shape-color
        *ngSwitchCase="'shapeColor'"
        class="menu-group"
        [color]="selectedObject.shapeColor"
        (colorChanged)="updateNodeProperty('shapeColor', $event, true)"
      ></y42-context-menu-shape-color>
      <y42-context-menu-border-color
        *ngSwitchCase="'shapeBorder'"
        class="menu-group"
        [borderColor]="selectedObject.shapeBorder"
        (borderColorChanged)="updateNodeProperty('shapeBorder', $event, true)"
      ></y42-context-menu-border-color>
      <y42-context-menu-group
        *ngSwitchCase="'groupSelection'"
        class="menu-group"
        [canGroup]="selectedObject.canGroup"
        [canUngroup]="selectedObject.canUngroup"
        (groupSelection)="onGroupSelection()"
        (ungroupSelection)="onUngroupSelection()"
      ></y42-context-menu-group>
      <y42-context-menu-border-style
        *ngSwitchCase="'borderStyle'"
        class="menu-group"
        [borderStyle]="selectedObject.borderStyle"
        (borderStyleChanged)="updateNodeProperty('borderStyle', $event, true)"
      ></y42-context-menu-border-style>
      <y42-context-menu-delete *ngSwitchCase="'delete'" (deleteClick)="onDeleteClick()"></y42-context-menu-delete>
    </ng-container>
  </ng-container>
</y42-canvas-context-menu-toolbar>

<div
  *ngIf="!!singleChatRoomConfig && !!state.idAndUiIdForChatRoom?.uiId"
  class="chat-single-room-wrapper border-solid rounded-md"
  [ngStyle]="{
    display: (menuPosition?.y || 0) - 120 >= 0 ? 'flex' : 'none',
    top: !!menuPosition ? menuPosition.y + 'px' : 'inherit',
    left: !!menuPosition ? menuPosition.x + 40 + 'px' : 'inherit'
  }"
>
  <y42-chat-single-room
    class="flex flex-col w-full h-full"
    [chatRoomKey]="singleChatRoomConfig.key"
    [chatRoomTarget]="singleChatRoomConfig.target"
    [chatRoomStrategy]="singleChatRoomConfig.strategy"
    [relatedGitEntityPath]="singleChatRoomConfig.relatedGitEntityPath"
    [multipleStrategyIds]="state.idAndUiIdForChatRoom"
    (chatResolved)="removeChatPinForChatRoom($event)"
    (uiIdToRealId)="chatRoomCreated($event)"
  ></y42-chat-single-room>
</div>
